<template>
  <v-dialog :value="showDialog"
    :retain-focus="false"
    persistentimageColorSettings
    @click:outside="closeDialog"
    :content-class="contentClasses">
    <v-card>
      <v-card-text class="escalon-dialog-content justify-center">
        <annotation-color-picker
          :value="shapeFillColor"
          @input="updateColor($event)"/>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import annotationColorPicker from "../../components/imageBrowser/controls/AnnotationColorPicker";
import imageAnnotationHelper from "../../components/mixins/ImageAnnotationHelper";
import { mapGetters } from "vuex";
import { ANNOTATION_MODES } from "../../config/config";

export default {
  name: "ShapeFillDialog",
  components: { annotationColorPicker },
  mixins: [imageAnnotationHelper],
  computed: {
    ...mapGetters(["heightXs", "heightSm", "heightMd", "isShapeFillOpen", "sideBySideIsSynced", "sideBySideContext", "sideBySideLeftContext", "sideBySideRightContext"]),
    ...mapGetters({ "context": "shapeFillContext", "syncContext": "shapeFillSyncContext"}),
    showDialog() {
      return this.isShapeFillOpen;
    },
    contentClasses() {      
      var classes = "download-dialog ";
      if (this.sideBySideContext) {
        if (this.context == this.sideBySideLeftContext) classes += "shape-fill-left";
        else if (this.context == this.sideBySideRightContext) {
          if (this.heightXs || this.heightSm || this.heightMd) classes += "shape-fill-right-small";
          else classes += "shape-fill-right";
        }
        else classes += "invisible"
      }
      else {
        if (this.heightXs || this.heightSm || this.heightMd) classes += "shape-fill-small";
        else classes += "shape-fill-large";
      }
      return classes
    }
  },
  methods: {
    closeDialog() {
      this.$store.commit("setShapeFillContext", null);
      this.$store.commit("setShapeFillSyncContext", null);
    },
    updateColor(color) 
    {
      this.setAnnotationMode(ANNOTATION_MODES.ShapeFill);
      this.updateShapeFillColor(color);
      this.closeDialog();
    }
  }
};
</script>